// extracted by mini-css-extract-plugin
export var card = "_ks-5";
export var cardSelected = "_ks-4";
export var image = "_ks-3";
export var modal = "_ks-0";
export var modalContent = "_ks-1";
export var table = "_ks-2";